(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["cc-project-slider"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.cps-block').forEach((root) => {
    if (root.dataset.cpsInit === 'true') return;
    root.dataset.cpsInit = 'true';

    const track = root.querySelector('.cps-track');
    const items = track ? Array.from(track.children) : [];
    const nav = root.querySelector('.cps-nav');
    const prev = root.querySelector('.cps-prev');
    const next = root.querySelector('.cps-next');
    const dots = root.querySelectorAll('.cps-dots .cps-dot');

    if (!track || !items.length) return;

    function stepWidth() {
      const styles = getComputedStyle(track);
      const gap = parseFloat(styles.gap || 0);
      const item = items[0];

      return item ? item.getBoundingClientRect().width + gap : track.clientWidth;
    }

    function go(dir) {
      const sw = stepWidth();
      const maxScroll = track.scrollWidth - track.clientWidth;
      const target = Math.max(0, Math.min(track.scrollLeft + dir * sw, maxScroll));

      track.scrollTo({
        left: target,
        behavior: 'smooth'
      });
    }

    // Pfeile ausblenden, wenn gar nichts zu scrollen ist (zu wenige Karten für
    // die aktuelle Breite), und einzeln deaktivieren am jeweiligen Ende.
    function updateNav() {
      const maxScroll = track.scrollWidth - track.clientWidth;
      const scrollable = maxScroll > 1;

      if (nav) nav.hidden = !scrollable;
      if (prev) prev.disabled = !scrollable || track.scrollLeft <= 1;
      if (next) next.disabled = !scrollable || track.scrollLeft >= maxScroll - 1;
    }

    function updateDots() {
      if (!dots.length) return;

      const idx = Math.round(track.scrollLeft / stepWidth());

      dots.forEach((dot, index) => {
        if (index === idx) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    }

    if (prev) prev.addEventListener('click', () => go(-1));
    if (next) next.addEventListener('click', () => go(1));

    function update() {
      updateNav();
      updateDots();
    }

    track.addEventListener('scroll', () => {
      requestAnimationFrame(update);
    });

    // Fängt Breakpoint-Wechsel und nachladende Bilder gleichermaßen ab.
    if (window.ResizeObserver) {
      new ResizeObserver(update).observe(track);
    } else {
      window.addEventListener('resize', update);
    }

    update();

    const autoplayEnabled = root.dataset.autoplayEnable === 'true';
    const autoplayInterval = parseInt(root.dataset.autoplayInterval, 10) || 4000;
    let autoplayTimer = null;

    function autoplayStart() {
      if (!autoplayEnabled || !items.length) return;
      autoplayStop();

      autoplayTimer = setInterval(() => {
        go(1);
      }, autoplayInterval);
    }

    function autoplayStop() {
      if (!autoplayTimer) return;

      clearInterval(autoplayTimer);
      autoplayTimer = null;
    }

    if (autoplayEnabled && !root.classList.contains('is-grid-desktop')) {
      autoplayStart();

      root.addEventListener('mouseenter', autoplayStop);
      root.addEventListener('mouseleave', autoplayStart);
    }
  });
  } catch(e) { console.error(e); }
})();

})();
